import { TableRow, TableCell, Typography } from "@mui/material";
import { TableBody } from "@mui/material";
import { DataTable } from "~/components/data-table/data-table";
import { TableHead } from "~/pages/inventory/components/TableHead";
import { StatusCell } from "~/components/Cells/StatusCell";
import { TitleCell } from "~/components/Cells/TitleCell";
import { SecurityPipelineGithubWorkflowsTableRow } from "./types";
import { getWorkflowStatusCellLabel } from "./utils/statuses";
import { getWorkflowStatusCellVariant } from "./utils/statuses";
import { Flex } from "~/components/Flex";
import { Paginate, PaginateProps } from "~/components/pagination/paginate";
import { SECURITY_PIPELINE_GITHUB_WORKFLOWS_TABLE_HEADERS } from "./constants";
import { Link as RouterLink } from "react-router-dom";
import { useScope } from "~/hooks/useScope";
import { SecurityPipelineWorkflowOrder } from "~/operations/types";
import { getWorkflowUrl } from "~/pages/integrations/workflow/utils";

interface SecurityPipelineGithubWorkflowsTableProps {
  rows: SecurityPipelineGithubWorkflowsTableRow[];
  paginationProps: PaginateProps;
  onStatusClick: (row: SecurityPipelineGithubWorkflowsTableRow) => void;
  onSort: (id: string) => void;
  orderBy: SecurityPipelineWorkflowOrder;
}

export const SecurityPipelineGithubWorkflowsTable = ({
  rows,
  paginationProps,
  onStatusClick,
  onSort,
  orderBy,
}: SecurityPipelineGithubWorkflowsTableProps) => {
  const { activeScope } = useScope();
  return (
    <Flex flexDirection="column">
      <DataTable id="activity-history-table">
        <TableHead
          tableHeaders={SECURITY_PIPELINE_GITHUB_WORKFLOWS_TABLE_HEADERS}
          onSort={onSort}
          orderBy={orderBy}
        />
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.mrn}
              to={getWorkflowUrl({
                workflowMrn: row.mrn,
                params: activeScope?.params,
              })}
              component={RouterLink}
            >
              <TitleCell title={row.taskName} />
              <TableCell>
                <Typography>{row.author}</Typography>
              </TableCell>
              <TableCell>
                <Typography>{row.lastUpdated}</Typography>
              </TableCell>
              <StatusCell
                label={getWorkflowStatusCellLabel(row.status)}
                progress={row.progress}
                variant={getWorkflowStatusCellVariant(row.status)}
                onClick={() => onStatusClick(row)}
              />
            </TableRow>
          ))}
        </TableBody>
      </DataTable>
      {paginationProps && <Paginate {...paginationProps} />}
    </Flex>
  );
};
